import { useState } from "react";
import { faqs } from "@/mocks/homeData";
import SectionHeader from "./SectionHeader";

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  const [more, setMore] = useState(false);

  const visible = more ? faqs : faqs.slice(0, 4);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 px-4 md:grid-cols-5 md:px-6">
        <div className="md:col-span-2">
          <SectionHeader
            eyebrow="常见问题"
            title="关于吃瓜 你可能想问"
            desc="关于存图、更新、投稿与授权的问题都在这里。没有找到答案，也可以通过投稿邮箱直接找我们。"
          />
          <div className="mt-7 rounded-2xl bg-accent-100 p-5">
            <p className="text-sm font-semibold text-accent-800">仍有疑问？</p>
            <p className="mt-1 text-sm text-foreground-600">把问题发给我们，工作人员会尽快回复。</p>
            <a
              href="mailto:hello@52chigua.cn"
              className="mt-3 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-600 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-accent-700 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line" /> hello@52chigua.cn
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="flex flex-col divide-y divide-background-200 rounded-2xl border border-background-200/70 bg-background-100">
            {visible.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-semibold text-foreground-900">{f.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm transition-transform duration-300 ${
                        isOpen ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className="ri-add-line" />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 rise-in">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
          {!more && faqs.length > 4 && (
            <button
              type="button"
              onClick={() => setMore(true)}
              className="mt-4 inline-flex items-center gap-2 rounded-full border border-background-300 px-5 py-2 text-sm font-semibold text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
            >
              展开全部问题
              <i className="ri-arrow-down-s-line" />
            </button>
          )}
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </section>
  );
}